export const classes = {
  menuItem: 'pl-4 pr-6 mx-2 my-1',
  inputLabel: 'size-full flex items-center cursor-pointer',
  input: 'hidden',
  divider: 'mx-4',
};
